import { adaptSearchResults } from './adapt-search-results';
import { sortByType } from './sort-by-type';
import { SearchResponseData, SearchResultData } from '../../types';

export function getSearchResults(
	data: SearchResponseData,
): Array<SearchResultData> {
	return [...adaptSearchResults(data)].sort(sortByType);
}
